






















































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

import EditAbout from '@/components/lfs/Company/ModalItems/EditAbout.vue'
import EditBadge from '@/components/lfs/Badges/ModalItems/EditContact.vue'
import EditLink from '@/components/lfs/Badges/ModalItems/EditLink.vue'

import { ServerCompany } from '@/utils/ServerCompany'
import { Company, Contact, Location, Promo } from '@/store/modules/lib'
import {namespace} from "vuex-class"
import {log} from "util";

const roistat = namespace('roistat')
const profile = namespace("profile")

@Component({
  name: 'c-company-edit-modal',

  components: {
    EditAbout,
    EditBadge,
    EditLink
  }
})
export default class CompanyEditModal extends Vue {
  @roistat.Action('sendEvent') protected sendEvent:any
  @profile.State("userCompany") protected userCompany: any
  @profile.Mutation('changeContacts') protected changeContacts: any

  @Prop(Object) company!: Company
  @Prop({type: [Boolean], default: false}) protected isOpen!: boolean

  
  @Watch('company')
  getComp(NewVal: any) {
    this.formValue = {...NewVal}
  }
  
  @Watch('isOpen')
  reset() {
    if(!this.isOpen) this.currentTab = 'tab-1'
  }

  currentTab: string = 'tab-1'
  formValue: any = {...this.company}
  deleteItems: any[] = []

  onSubmit (): void {
    const formValue = this.userCompany
    console.log('boom')
    if (formValue) {
      //правим "О себе"
     const respAbout =  ServerCompany.update(formValue)

      let respCont

      //правим и добавляем "Контакты"
      formValue.contacts.forEach((contact: Contact) => {
        if(contact.type === 'address') {
          respCont = ServerCompany.addAddress(formValue._id, contact)
        } else {
          if(contact.id) {
            respCont = ServerCompany.editContact(formValue._id, contact.id, contact)
          } else {
            respCont = ServerCompany.addContact(formValue._id, contact)
          }
        }
      })

      let respAdress
      //правим адрес
      formValue.locations.forEach((location: Location) => {
        respAdress = ServerCompany.editAddress(formValue._id, location)
      })

      let respLink
      //добавляем ссылки
      formValue.promo.forEach((promo: Promo) => {
        if(promo.type === 'link') {
          if(!promo.id) {
            respLink = ServerCompany.addPromo(formValue._id, promo)
          }
        }
      })

      let respDel
      //Удаляем
      this.deleteItems.forEach(item => {
        if(item.type === 'link') {
          respDel = ServerCompany.deletePromo(formValue._id, item.id)
        } else if(item.type === 'contacts') {
          respDel = ServerCompany.deleteContact(formValue._id, item.id)
        } else if (item.type === "address") {
          respDel = ServerCompany.deleteAddress(formValue._id, item.id)
        }
      })

      Promise.all([respDel,respLink,respAdress,respCont,respAbout]).then(()=>{
        ServerCompany.getCompanyById(formValue._id)
          .then((res: any) => {
            console.log('boom')
            this.$store.commit('profile/setStandCompany', res.data.Company)
            // this.formValue = res.data.Company
            let params = [
              {
                "name": "“Профиль”: Действие “Редактирование стенда”, изменения сохранены",
                "data": {
                  "company": this.userCompany.title
                }
              }
            ]
            this.sendEvent(params)
            this.onClose()
          })
      })

      //получаем компанию с новыми данными и сохраняем в store

    }

    this.onClose()


  }

  onClose (): void {
    this.$emit('closeModal')
    this.deleteItems = []
    this.formValue = {...this.company}
  }

  onChange (e: any): void {
    this.formValue = {...this.formValue, ...e}
  }

  onChangeLocations (e: any): void {
    this.formValue.locations = e
  }

  onDelete (val: any): void {
    if(val.type === 'link') {
      let payload = {
        id: this.userCompany.id,
        contacts: this.userCompany.contacts,
        promo: this.userCompany.promo.filter((item:any) => item != val.item),
        locations: this.userCompany.locations,
        isCurrentCompany: true
      }
      this.changeContacts(payload)
    }

    if(val.type == 'contacts') {
      let payload = {
        id: this.userCompany.id,
        contacts: this.userCompany.contacts.filter((item:any) => item != val.item),
        promo: this.userCompany.promo,
        locations: this.userCompany.locations,
        isCurrentCompany: true
      }
      this.changeContacts(payload)
    }

    if(val.type == 'address') {
      let payload = {
        id: this.userCompany.id,
        contacts: this.userCompany.contacts,
        promo: this.userCompany.promo,
        locations: this.userCompany.locations.filter((item:any) => item != val.item),
        isCurrentCompany: true
      }
      this.changeContacts(payload)
    }

    if(val.item.id) {
      this.deleteItems.push({ id: val.item.id, type: val.type })
    }
  }

  // beforeMount (): void {
  //   this.formValue = {...this.company}
  //   console.log("CompanyEditModal",this.formValue)
  // }
}
